<template>
  <vetster-information-carousel
    content-height="h-[38rem] xs:h-[24rem] md:h-[35rem] lg:h-[30rem] xl:h-[22rem]"
    description-classes="font-title text-xl md:text-3xl lg:px-24"
    :slides="testimonials"
  />
</template>

<script>
import VetsterInformationCarousel from '@/components/VetsterInformationCarousel';

export default {
  name: 'VetsterForVetsTestimonials',

  components: { VetsterInformationCarousel },

  data() {
    return {
      testimonials: [
        {
          author: this.$t('for-vets.testimonial-1.author'),
          description: this.$t('for-vets.testimonial-1.description'),
        },
        {
          author: this.$t('for-vets.testimonial-2.author'),
          description: this.$t('for-vets.testimonial-2.description'),
        },
        {
          author: this.$t('for-vets.testimonial-3.author'),
          description: this.$t('for-vets.testimonial-3.description'),
        },
      ],
    };
  },
};
</script>
